import { render, staticRenderFns } from "./UsersChip.vue?vue&type=template&id=c61c6d86&scoped=true"
import script from "./UsersChip.vue?vue&type=script&lang=js"
export * from "./UsersChip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c61c6d86",
  null
  
)

export default component.exports